module.exports = __webpack_public_path__ + "img/515-42dfb3.png";